import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(getGlobalItems),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(watchGetGlobalItems);

import { take, put, call, fork } from 'redux-saga/effects';
import makeApiRequest from '../../../utils/makeApiRequest';
import { GET_GLOBAL_ITEMS, getGlobalItemsRequest, getGlobalItemsFailure, getGlobalItemsSuccess } from '../../../redux/globalList/getItems';
import { queryGetWishlistPartNumbers } from '../../../utils/gql-queries';
import flattenQuery from '../../../utils/flattenQuery'; // -------------------------------------------------
// WORKER SAGAS
// -------------------------------------------------

export function getGlobalItems(requestQuery) {
  var payload;
  return _regeneratorRuntime.wrap(function getGlobalItems$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(getGlobalItemsRequest());

        case 2:
          _context.prev = 2;
          _context.next = 5;
          return call(makeApiRequest, {
            methodType: 'post',
            url: '/wishlist-service/gql-wishlist',
            body: requestQuery
          });

        case 5:
          payload = _context.sent;
          _context.next = 8;
          return put(getGlobalItemsSuccess(payload.data));

        case 8:
          _context.next = 14;
          break;

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](2);
          _context.next = 14;
          return put(getGlobalItemsFailure(_context.t0));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[2, 10]]);
} // -------------------------------------------------
// WATCHER SAGAS
// -------------------------------------------------

export default function watchGetGlobalItems() {
  var _yield$take, requestQuery;

  return _regeneratorRuntime.wrap(function watchGetGlobalItems$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!true) {
            _context2.next = 9;
            break;
          }

          _context2.next = 3;
          return take(GET_GLOBAL_ITEMS);

        case 3:
          _yield$take = _context2.sent;
          requestQuery = _yield$take.requestQuery;
          _context2.next = 7;
          return fork(getGlobalItems, flattenQuery(requestQuery || queryGetWishlistPartNumbers));

        case 7:
          _context2.next = 0;
          break;

        case 9:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}